import {createAsyncThunk} from '@reduxjs/toolkit'

import {PAYMENT_METHOD_CHANGE_POST_MESSAGE_KEY as MESSAGE_KEY} from '@web/core/constants'
import {ROUTER_ORDER_PAYMENT_METHODS} from '@web/core/routes'
import {changeBrowserLocation, subscribeMessage, unsubscribeMessage, openPopup} from '@web/helpers/browser'
import {urlMergedWithUnverifiedUrlParam} from '@web/helpers/path'
import {isMobile} from '@web/helpers/userAgent'

import {LocationChangeHistoryParam, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

type NavigateToShoppingSubscriptionPaymentMethodManagementParam = LocationChangeHistoryParam &
    NavigationTypeSelectableParam & {rurl?: string}

const POPUP_KEY = 'SHOPPING_SUBSCRIPTION_PAYMENT_METHOD_MANAGEMENT'

/**
 * 정기구독 결제수단 변경 페이지로 이동
 * - Route 로의 이동 기능을 제공합니다. (routeBased: true)
 */
export const navigateToShoppingSubscriptionPaymentMethodManagement = createAsyncThunk<
    string | void,
    NavigateToShoppingSubscriptionPaymentMethodManagementParam | void,
    ThunkApi
>('navigateTo/shoppingSubscriptionPaymentMethodManagement', async (args) => {
    const shouldChangeLocation = args?.forceLocationChange || isMobile

    const url = `${window.location.origin}${`${ROUTER_ORDER_PAYMENT_METHODS.ROOT}/subscription`}`

    if (shouldChangeLocation) {
        const rurl = args?.rurl ?? window.location.href

        changeBrowserLocation({
            type: args?.historyType ?? 'PUSH',
            url: urlMergedWithUnverifiedUrlParam(url, {rurl, exitType: 'push'}),
        })

        return Promise.resolve()
    }

    return new Promise<void | string>((resolve, reject) => {
        const resolveCallback = (result: {content: string; key: string}) => {
            if (result.content === 'SUCCESS') {
                return resolve(result.content)
            }

            resolve()
        }

        // popup으로부터 유효한 메시지 받았을 때만 result로  메시지 전달
        subscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})

        openPopup({
            key: POPUP_KEY,
            url,
            title: '정기구독 자동 결제수단 변경',
            size: {
                width: 500,
                height: 640,
            },
        })
            .then(() => resolve())
            .catch(reject)
            .finally(() => {
                // popup open 실패했든 종료했든 popup open시도가 끝났다면 message subscription 종료
                unsubscribeMessage({
                    messageKey: MESSAGE_KEY,
                    subscriber: resolveCallback,
                })
            })
    })
})

export default navigateToShoppingSubscriptionPaymentMethodManagement
